import site from "data/site.json"
import projects from "data/previous-projects.json"
import socials from "data/social.json"

export const pipkin = projects.find((project) => project.id === "pipkin")

export const organization = {
  "@type": "Organization",
  "@id": `${site.url}/#organization`,
  name: site.name,
  url: `${site.url}/`,
  logo: `${site.url}${site.logo}`,
  sameAs: [
    `${pipkin.website}#organization`,
    ...socials.filter((social) => social.url).map((social) => social.url),
  ],
}

export const website = {
  "@type": "WebSite",
  "@id": `${site.url}/#website`,
  name: site.name,
  url: `${site.url}/`,
  publisher: { "@id": organization["@id"] },
  inLanguage: "en-GB",
}

export const pipkinGame = {
  "@type": ["VideoGame", "MobileApplication"],
  "@id": `${pipkin.website}#app`,
  name: pipkin.name,
  url: pipkin.website,
  description: pipkin.description,
  image: `${site.url}${pipkin.image}`,
  applicationCategory: "GameApplication",
  creator: { "@id": organization["@id"] },
  publisher: { "@id": organization["@id"] },
  typicalAgeRange: "2-7",
  creativeWorkStatus: "In development",
  inLanguage: "en-GB",
}
